function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.945 9.485H5.698a.312.312 0 0 0-.312.312v.624c0 .172.14.312.312.312h1.247c.173 0 .312-.14.312-.312v-.624a.312.312 0 0 0-.312-.312zM4.45 8.238h-.935V2.312A.312.312 0 0 0 3.203 2h-.624a.312.312 0 0 0-.312.312v5.926h-.936a.312.312 0 0 0-.22.532l1.56 1.872c.122.121.319.121.44 0l1.56-1.872a.312.312 0 0 0-.22-.532zm4.99-3.743H5.699a.312.312 0 0 0-.312.312v.624c0 .172.14.312.312.312H9.44c.172 0 .311-.14.311-.312v-.624a.312.312 0 0 0-.311-.312zM8.194 6.99H5.698a.312.312 0 0 0-.312.312v.624c0 .172.14.312.312.312h2.495c.172 0 .312-.14.312-.312v-.624a.312.312 0 0 0-.312-.312zM10.688 2h-4.99a.312.312 0 0 0-.312.312v.624c0 .172.14.312.312.312h4.99c.172 0 .312-.14.312-.312v-.624A.312.312 0 0 0 10.688 2z"
});

function SvgIconSortDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSortDown);
export default __webpack_public_path__ + "static/media/icon-sort-down.0189b11e.svg";
export { ForwardRef as ReactComponent };